module.exports = __webpack_public_path__ + "static/media/bg_Page03.12fa8873.jpg";